import { useEffect, useRef, useState } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import * as customerApis from "../../utilities/apis/customer"
import * as zoneApis from "../../utilities/apis/zone"
import Layout from "../../components/Layout"

const Customer = () => {
  const navigate = useNavigate()
  const { user, token } = useSelector(state => state.user)
  const nameRef = useRef(null)
  const mobileRef = useRef(null)
  const addressRef = useRef(null)
  const tagsRef = useRef(null)
  const lastOrderRef = useRef(null)
  const zoneRef = useRef(null)
  const params = new URLSearchParams(window.location.search)
  const [zones, setZones] = useState([])

  const handleSubmit = async (e) => {
    try {
      e.preventDefault()

      const name = e.target.name.value || null
      const mobile = e.target.mobile.value
      const address = e.target.address.value
      const tags = e.target.tags.value || null
      const lastOrder = e.target.order_at.value || null
      const zone = e.target.zone_id.value || null
      const payload = { name, mobile, address, tags, last_order: lastOrder, zone_id: zone }

      if (!params.has("id")) {
        const response = await customerApis.createCustomer(token, payload)
        if (!response.status) throw new Error(response.message)

        nameRef.current.value = ""
        mobileRef.current.value = ""
        addressRef.current.value = ""
        tagsRef.current.value = ""
        lastOrderRef.current.value = ""
        zoneRef.current.value = zones[0].id
      } else {
        payload.id = parseInt(params.get("id"))
        const response = await customerApis.updateCustomer(token, payload)
        if (!response.status) throw new Error(response.message)
      }

      alert("Customer saved")
    } catch (error) {
      alert(error.message)
    }
  }

  const getCustomer = async () => {
    try {
      const response = await customerApis.getCustomer(token, params.get("id"))
      if (!response.status) throw new Error(response.message)

      if (response.customer.name) nameRef.current.value = response.customer.name
      mobileRef.current.value = response.customer.mobile
      addressRef.current.value = response.customer.address
      if (response.customer.tags) tagsRef.current.value = response.customer.tags
      if (response.customer.last_order) lastOrderRef.current.value = moment(response.customer.last_order).format("YYYY-MM-DDTHH:mm")
      zoneRef.current.value = response.customer.zone_id
    } catch (error) {
      alert(error.message)
    }
  }

  const getZones = async () => {
    try {
      const response = await zoneApis.getZones(token, "")
      if (!response.status) throw new Error(response.message)

      setZones(response.zones)
    } catch (error) {
      alert(error.message)
    }
  }

  useEffect(() => {
    if (!user) navigate("/")

    getZones()
    if (params.has("id"))
      getCustomer()
  }, [])

  return (
    <Layout
      header={true}
      footer={true}
    >
      <main className="py-3">
        <div className="container">
          <form method="POST" onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-3">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex gap-3 align-items-center">
                  <button type="button" className="btn btn-secondary rounded-4" onClick={() => navigate(-1)}><i className="bi bi-chevron-left"></i></button>
                  <p className="lead text-body-emphasis fw-bold m-0">{params.has("id") ? "Edit" : "Add"} Customer</p>
                </div>
                <button type="submit" className="btn btn-theme rounded-4">Save</button>
              </div>

              <div className="row">
                <div className="col-md-8">
                  <div className="d-flex flex-column gap-3">
                    <div className="card rounded-4 shadow-none">
                      <div className="card-body py-4">
                        <div className="d-flex flex-column gap-3">
                          <div>
                            <label htmlFor="name" className="form-label">Name</label>
                            <input ref={nameRef} type="text" name="name" className="form-control" id="name" />
                          </div>
                          <div>
                            <label htmlFor="mobile" className="form-label">Mobile #</label>
                            <input ref={mobileRef} type="tel" name="mobile" className="form-control" id="mobile" required />
                          </div>
                          <div>
                            <label htmlFor="last-order" className="form-label">Last Order</label>
                            <input ref={lastOrderRef} type="datetime-local" name="order_at" className="form-control" id="last-order" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="card rounded-4 shadow-none">
                      <div className="card-body py-4">
                        <div className="d-flex flex-column gap-3">
                          <div>
                            <label htmlFor="address" className="form-label">Address</label>
                            <input ref={addressRef} type="text" name="address" className="form-control" id="address" required />
                          </div>
                          <div>
                            <label htmlFor="zone" className="form-label">Zone</label>
                            <select ref={zoneRef} name="zone_id" className="form-select" id="zone">
                              {zones.map((zone) => (
                                <option key={zone.id.toString()} value={zone.id}>{zone.name}</option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="card rounded-4 shadow-none">
                    <div className="card-body py-4">
                      <div className="d-flex flex-column gap-3">
                        <div>
                          <label htmlFor="tags" className="form-label">Tags</label>
                          <input ref={tagsRef} type="text" className="form-control" id="tags" placeholder="Discount, Good, Delightful, etc" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </main>
    </Layout>
  )
}

export default Customer
